import Text from '@adsk/bim360-matrix-react-text';
import {NotificationLevels, NotificationTypes} from '@adsk/bim360-matrix-react-notification-manager';
import {showNotificationAction} from '../app/actions';
import React from 'react';
import i18n from './i18n';

/**
 * Returns a reference to a promise and to it's resolve and reject methods
 * We need the reference to resolve and reject so we can resolve or reject this promise when needed
 * @returns {{promise: Promise, resolve: *, reject: *}}
 */
export const getPromiseForAsyncNotification = () => {
  let promiseResolve, promiseReject;
  const promise = new Promise((resolve, reject) => {
    promiseResolve = resolve;
    promiseReject = reject;
  });
  return {
    promise,
    resolve: promiseResolve,
    reject: promiseReject
  };
};

export const trimFileName = (fileName, maxCharacters) =>
  fileName.length > maxCharacters
    ? `${fileName.substr(0, maxCharacters - 7)}...${fileName.substr(fileName.length - 4)}`
    : fileName;

export const locationChangeNotification = locationName =>
  showNotificationAction({
    type: NotificationTypes.TOAST,
    level: NotificationLevels.SUCCESS,
    message: <Text hasHTML>{i18n.t('notifications.updateLocation', {locationName})}</Text>
  });
